
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Heading, Row, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { IInstrumentStatistics } from '@/modules/trade/services/instruments';

@Component({
  components: {
    BaseText,
    Heading,
    Row
  }
})
export default class InstrumentStatistics extends Vue {
  @Prop({ type: Object, required: true })
  public statistics!: IInstrumentStatistics;

  public get NebraskaColors() {
    return NebraskaColors;
  }

  public get dailyVariationClass() {
    return this.statistics.dailyVariation?.value >= 0
      ? 'instrument-statistics__positive'
      : 'instrument-statistics__negative';
  }
}
